module.exports = __webpack_public_path__ + "img/logo_dark.0a30b011.svg";